/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Card
 * @desc ExperimentWorkflow Card
 */

import { ExperimentWorkflowActionMenu } from 'labstep-web/components/ExperimentWorkflow/Action/Menu';
import { ExperimentWorkflowCardSubTitle as SubTitle } from 'labstep-web/components/ExperimentWorkflow/Card/SubTitle';
import { GenericCard } from 'labstep-web/core/Card/Generic';
import type React from 'react';
import type { ExperimentWorkflowCardProps } from './types';

export const ExperimentWorkflowCard: React.FC<
  ExperimentWorkflowCardProps
> = ({ experimentWorkflow, actions, createdBy, mainActionType }) => (
  <GenericCard
    headerTitle={{
      to: 'experiment_workflow_show',
      params: { id: experimentWorkflow.id },
      title: experimentWorkflow.displayName,
      disabled: mainActionType === 'delete',
    }}
    customSubtitle={
      <SubTitle
        createdBy={createdBy}
        experimentWorkflow={experimentWorkflow}
      />
    }
    actionMenu={
      actions && (
        <ExperimentWorkflowActionMenu
          experimentWorkflow={experimentWorkflow}
          actions={actions}
        />
      )
    }
  />
);
